'use client'

import { useSyncExternalStore } from 'react'
import { hasCaptchaBeenUsed, subscribeToCaptchaUsage } from '@/app/_trpc/captcha-browser'

/*
 * Google's floating reCAPTCHA badge sits outside React, appended to `body`.
 * While this disclosure is on screen it replaces the badge, so the badge is
 * hidden by a `<style>` that mounts and unmounts with the disclosure. A plain
 * element instead of a `body:has(...)` rule: that selector made every page
 * holding the badge re-check the whole document on each DOM change.
 */
const HIDE_BADGE_CSS = '.grecaptcha-badge{visibility:hidden}'

export function CaptchaDisclosure() {
  const used = useSyncExternalStore(subscribeToCaptchaUsage, hasCaptchaBeenUsed, () => false)

  if (!used) return null

  return (
    <>
      <style>{HIDE_BADGE_CSS}</style>
      <p className='pt-2 text-contentSecondary text-xs'>
        Ta strona jest chroniona przez reCAPTCHA.
      </p>
    </>
  )
}
